module.exports = __webpack_public_path__ + "img/Indonesia-03.99b34f23.jpg";